import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { VendorBankRequest } from '../models/vendor.model';
import { ResponseObject } from '../models/response-object.model';

@Injectable({
  providedIn: 'root'
})
export class VendorBankService {
  private URL = environment.api;
  constructor(
    private http: HttpClient
  ) { }


  createVendorBank(request: VendorBankRequest, company: any) {
    return this.http.post<ResponseObject>(this.URL + 'api/erp/vendorBank', request);
  }

  updateVendorBank(request: VendorBankRequest, company: any) {
    return this.http.put<ResponseObject>(this.URL + `api/erp/vendorBank/${request.id}`, request);
  }

  getBanks() {
		return this.http.get(this.URL + "api/bank/all");
	}

  getVendorBanksByVendorId(idVendor) {
		return this.http.get(this.URL + `api/erp/vendorBank/vendor/${idVendor}`);
	}
  
}
